export const formatPhoneToDisplayView = (dirtyPhone: string) => {
  const phone = dirtyPhone.replace(/[-_()\s]/g, '');
  const { length } = phone;

  if (length < 10) {
    return phone;
  }

  const parts = [
    phone.slice(0, length - 10),
    phone.slice(length - 10, length - 7),
    phone.slice(length - 7, length - 4),
    phone.slice(length - 4, length - 2),
    phone.slice(length - 2, length),
  ].filter(Boolean);

  const formattedPhone = parts.join(' ');

  return formattedPhone.startsWith('7') ? `+${formattedPhone}` : formattedPhone;
};
